
import { Vue, Component, Prop } from 'vue-property-decorator';
import { HistoryItemType } from '@/features/shipment-history/types';

@Component
export default class ShipStatus extends Vue {
  @Prop({ required: true }) item!: HistoryItemType;

  @Prop({ required: true }) visibleStatuses!: string[];

  @Prop({ required: true }) invisibleStatuses!: string[];

  @Prop({ required: true }) packagesExpanded!: boolean;

  private getStatusMarkStyle = (status: string): { [key: string]: string } => {
    const colorByStatus = {
      created: '#623ec7',
      intransit: '#ffa43c',
      exception: '#cb0f51',
      delivered: '#2bc5cb',
    };

    return {
      backgroundColor: colorByStatus[status.replaceAll(' ', '').toLowerCase()],
    };
  }
}
